<template>
  <div class="dashboard-index" style="height: 100%">
    <div class="flex-row flex__between">
      <div
        class="
          header-title
          font-size__large
          flex-row flex__left
          color__black
          margin-bottom-10
        "
        v-if="!!user"
      ></div>
      <user-header />
    </div>
    <div class="style-fullWidth flex-row flex-right__top" style="height: 100%">
      <!--  main-->
      <div class="cards-area main-content-dashboard" style="height: 100%">
        <vue-perfect-scrollbar class="scroll-area">
          <el-row :gutter="24" style="margin-right: 3px">
            <div class="filter-dashboard">
              <div style="margin-top: 5px">
                <div
                  style="
                    margin-left: 12px;
                    height: 20px;
                    display: flex;
                    align-items: end;
                    font-weight: 700;
                    font-size: 18px;
                    color: #303133;
                  "
                >
                  Xin chào,
                  {{ `${user && user.fullName}` }}!
                </div>
                <div
                  style="
                    font-size: 13px;
                    margin-left: 12px;
                    color: rgb(136, 152, 170);
                    padding-top: 5px;
                  "
                >
                  {{
                    userDeptRole
                      ? userDeptRole.positionName + " " + userDeptRole.deptName
                      : ""
                  }}
                </div>
              </div>
              <div style="display: flex">
                <div style="width: 185px">
                  <el-date-picker
                    v-model="docDateRange"
                    type="daterange"
                    format="dd/MM/yyyy"
                    class="
                      style-fullWidth
                      input-border__bottom input-border__radius__0
                      bg__transparent
                    "
                    :picker-options="dateQuickFilterOption"
                    range-separator="_"
                    start-placeholder="_"
                    end-placeholder="_"
                    align="right"
                    :clearable="false"
                    @change="filterByDocDateRange"
                  >
                  </el-date-picker>
                </div>
                <!-- <div
                  style="
                    display: flex;
                    align-items: center;
                    height: 40px;
                    cursor: pointer;
                  "
                  title="Cấu hình dashboard"
                  @click="isOpenSettingDialog = true"
                >
                  <i class="fal fa-cog"></i>
                </div> -->
              </div>
            </div>
          </el-row>
          <el-row :gutter="24" style="margin-top: 15px">
            <el-col :span="24">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-wrap: wrap;
                "
              >
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="my-element">
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        VĂN BẢN ĐẾN
                      </h3>
                      <div
                        style="
                          color: #32325d;
                          font-weight: 600;
                          font-size: 1.25rem;
                        "
                      >
                        {{ dashboards.countOfIncomingDoc || 0 }}
                        <label style="color: #2dce89; font-size: 14px"
                          >({{
                            dashboards.countOfUnreadIncomingDoc || 0
                          }}
                          mới)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-red">
                        <i
                          style="color: #fff"
                          class="far fa-inbox-in fa-fw"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div
                    @click="viewListIncomingDocProcessing()"
                    style="
                      align-items: center;
                      display: flex;
                      justify-content: space-between;
                      border-top: solid 1px #e5e5e5;
                      height: 30px;
                      margin-top: 10px;
                      cursor: pointer;
                    "
                  >
                    <div>Xem chi tiết</div>
                    <div class="">
                      <i
                        style="font-size: 16px"
                        class="far fa-arrow-to-right"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="my-element">
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        VĂN BẢN ĐI
                      </h3>
                      <div
                        style="
                          color: #32325d;
                          font-weight: 600;
                          font-size: 1.25rem;
                        "
                      >
                        {{ dashboards.countOfOutGoingDoc || 0 }}
                        <label style="color: #2dce89; font-size: 14px"
                          >({{
                            dashboards.countOfUnreadOutGoingDoc || 0
                          }}
                          mới)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-orange">
                        <i
                          style="color: #fff"
                          class="far fa-inbox-out fa-fw"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div
                    @click="viewListOutgoingDocProcessing()"
                    style="
                      align-items: center;
                      display: flex;
                      justify-content: space-between;
                      border-top: solid 1px #e5e5e5;
                      height: 30px;
                      margin-top: 10px;
                      cursor: pointer;
                    "
                  >
                    <div>Xem chi tiết</div>
                    <div class="">
                      <i
                        style="font-size: 16px"
                        class="far fa-arrow-to-right"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="my-element">
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        CV TÔI GIAO
                      </h3>
                      <div>
                        <span
                          title="Xem công việc đang thực hiện"
                          style="cursor: pointer"
                          @click="viewListCVDaGiao('DANG_THUC_HIEN')"
                        >
                          <span
                            style="
                              color: #32325d;
                              font-weight: 600;
                              font-size: 1.25rem;
                            "
                            >{{
                              dashboards.countOfTaskAssignDangXuLy || 0
                            }}</span
                          >
                        </span>
                        <label
                          title="Xem công việc chờ duyệt"
                          @click="viewListCVDaGiao('CHO_PHE_DUYET_DK')"
                          style="
                            color: #2dce89;
                            font-size: 14px;
                            cursor: pointer;
                          "
                          >({{ dashboards.countOfTaskAssignChoPheDuyet }} chờ
                          duyệt)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-green">
                        <i style="color: #fff" class="fal fa-briefcase"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    @click="viewListCVDaGiao()"
                    style="
                      align-items: center;
                      display: flex;
                      justify-content: space-between;
                      border-top: solid 1px #e5e5e5;
                      height: 30px;
                      margin-top: 10px;
                      cursor: pointer;
                    "
                  >
                    <div>Xem chi tiết</div>
                    <div class="">
                      <i
                        style="font-size: 16px"
                        class="far fa-arrow-to-right"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="block-report">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 5px;
                    "
                  >
                    <div class="my-element">
                      <h3 style="color: #8898aa; margin-bottom: 2px">
                        CV ĐƯỢC GIAO
                      </h3>
                      <div>
                        <span
                          title="Xem công việc đang thực hiện"
                          style="cursor: pointer"
                          @click="viewListCVDuocGiao('DANG_THUC_HIEN')"
                        >
                          <span
                            style="
                              color: #32325d;
                              font-weight: 600;
                              font-size: 1.25rem;
                            "
                            >{{
                              dashboards.countOfTaskReciveDangXuLy || 0
                            }}</span
                          >
                        </span>
                        <label
                          @click="viewListCVDuocGiao('CHO_PHE_DUYET_DK')"
                          style="
                            color: #2dce89;
                            font-size: 14px;
                            cursor: pointer;
                          "
                          >({{ dashboards.countOfTaskReciveChoPheDuyet }} chờ
                          duyệt)</label
                        >
                      </div>
                    </div>
                    <div>
                      <div class="icon bg-gradient-info">
                        <i style="color: #fff" class="fal fa-briefcase"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    @click="viewListCVDuocGiao()"
                    style="
                      align-items: center;
                      display: flex;
                      justify-content: space-between;
                      border-top: solid 1px #e5e5e5;
                      height: 30px;
                      margin-top: 10px;
                      cursor: pointer;
                    "
                  >
                    <div>Xem chi tiết</div>
                    <div class="">
                      <i
                        style="font-size: 16px"
                        class="far fa-arrow-to-right"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <draggable
            v-model="configs"
            @change="changeSort"
            group="people"
            @start="drag = true"
            @end="drag = false"
            style="display: flex; flex-wrap: wrap"
            :force-fallback="true"
          >
            <div
              class="dashboard-item"
              v-for="element in configs"
              :key="element"
            >
              <div v-if="element === 'VB_DEN_LIST'" class="card-area">
                <doc-in-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VBDEN_CHO_XU_LY"
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Văn bản đến chờ xử lý'"
                  :docs="incomingDocs"
                  :docsCount="incomingDocsCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailIncomingDoc"
                  @viewMore="viewListIncomingDocProcessing"
                  @removeItem="() => removeItem(element)"
                >
                </doc-in-dashboard-card-v2>
              </div>
              <div v-if="element === 'VB_DI_LIST'" class="card-area">
                <doc-out-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VBDI_CHO_XU_LY"
                  :cardTitle="'Văn bản đi chờ xử lý'"
                  :docs="outgoingDocs"
                  :docsCount="outgoingDocsCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailOutgoingDoc"
                  @viewMore="viewListOutgoingDocProcessing"
                  @removeItem="() => removeItem(element)"
                >
                </doc-out-dashboard-card-v2>
              </div>
              <div v-if="element === 'VB_CHO_BAN_HANH'" class="card-area">
                <doc-out-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VB_CHO_BAN_HANH"
                  :cardTitle="'Văn bản chờ ban hành'"
                  :docs="vanBanChoBanHanh"
                  :docsCount="vanBanChoBanHanhCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailChoBanHanh"
                  @viewMore="viewMoreChoBanHanh"
                  @removeItem="() => removeItem(element)"
                >
                </doc-out-dashboard-card-v2>
              </div>
              <div v-if="element === 'VB_CHO_TIEP_NHAN'" class="card-area">
                <doc-in-dashboard-card-v2
                  :type="DASHBBOARD_TYPE.VB_CHO_TIEP_NHAN"
                  :cardTitle="'Văn bản chờ tiếp nhận'"
                  :docs="vanBanChoTiepNhan"
                  :docsCount="vanBanChoTiepNhanCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailChoTiepNhan"
                  @viewMore="viewMoreChoTiepNhan"
                  @removeItem="() => removeItem(element)"
                >
                </doc-in-dashboard-card-v2>
              </div>
              <div v-if="element === 'CV_DUOC_GIAO_LIST'" class="card-area">
                <job-dashboard-card
                  :type="DASHBBOARD_TYPE.CV_DUOC_GIAO"
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Công việc được giao'"
                  :jobs="returnListJob(dataCVDuocGiao)"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailCVDuocGiao"
                  @viewMore="viewListCVDaGiao"
                  @removeItem="() => removeItem(element)"
                >
                </job-dashboard-card>
              </div>
              <div v-if="element === 'CV_TOI_GIAO_LIST'" class="card-area">
                <job-dashboard-card
                  :type="DASHBBOARD_TYPE.CV_TOI_GIAO"
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Công việc tôi giao'"
                  :jobs="returnListJob(dataCVDaGiao)"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailCVDaGiao"
                  @viewMore="viewListCVDaGiao"
                  @removeItem="() => removeItem(element)"
                >
                </job-dashboard-card>
              </div>
              <bar-chart
                :key="`VB_DI_CHART${incomingChart}`"
                v-if="element === 'VB_DEN_CHART'"
                :type="DASHBBOARD_TYPE.VBDEN_CHO_XU_LY"
                title="Văn bản đến"
                :dataChart="incomingChart"
                @viewMore="viewListIncomingDocProcessing"
                @removeItem="() => removeItem(element)"
              />
              <bar-chart
                :key="`VB_DI_CHART${outgoingChart}`"
                v-if="element === 'VB_DI_CHART'"
                :type="DASHBBOARD_TYPE.VBDI_CHO_XU_LY"
                title="Văn bản đi"
                :dataChart="outgoingChart"
                @viewMore="viewListOutgoingDocProcessing"
                @removeItem="() => removeItem(element)"
              />
              <pie-chart
                :key="`VB_DI_CHART${CVDaGiaoChart}`"
                v-if="element === 'CV_TOI_GIAO_CHART'"
                :type="DASHBBOARD_TYPE.CV_TOI_GIAO"
                title="Công việc tôi giao"
                :dataChart="CVDaGiaoChart"
                @viewMore="viewListCVDaGiao"
                @removeItem="() => removeItem(element)"
              />
              <pie-chart
                :key="`VB_DI_CHART${CVDuocGiaoChart}`"
                v-if="element === 'CV_DUOC_GIAO_CHART'"
                :type="DASHBBOARD_TYPE.CV_DUOC_GIAO"
                title="Công việc được giao"
                :dataChart="CVDuocGiaoChart"
                @viewMore="viewListCVDuocGiao"
                @removeItem="() => removeItem(element)"
              />
            </div>
          </draggable>
        </vue-perfect-scrollbar>
      </div>
      <!--  main:end-->
      <!--  right-->
      <div class="notification-area">
        <notifications-card-v2
          :cardTitle="'Thông báo'"
          :notifis="notifications"
          :notifysCount="notificationsCount"
          :unreadNotifysCount="notificationsUnreadCount"
        >
        </notifications-card-v2>
      </div>
      <!--  right:end-->
    </div>
    <setting-display
      :isOpen="isOpenSettingDialog"
      :isVisibleIncommingDoc="isVisibleIncommingDoc"
      :isVisibleOutgoingDoc="isVisibleOutgoingDoc"
      :isVisibleCongViec="isVisibleCongViec"
      :isVisibleChoBanHanh="isVisibleChoBanHanh"
      :isVisibleChoTiepNhan="isVisibleChoTiepNhan"
      :configs="configs"
      v-if="isEnableSettingDialog"
      @dialogClosed="isEnableSettingDialog = false"
      @closeDialog="isOpenSettingDialog = false"
      @success="updateConfigSuccess"
    />
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import headerTemplate from "../../components/header/main-header.vue";
import dashBoardService from "../../services/dashBoardService";
import h from "../../services/h";
import IncomingDocsCard from "./IncomingDocsCard";
import OutgoingDocsCard from "./OutgoingDocsCard";
import CongViecCard from "./CongViecCard";
import NotifyCard from "./NotifyCard";
import ChoBanHanhCard from "./ChoBanHanhCard";
import ChoTiepNhanCard from "./ChoTiepNhanCard";
import constants from "../../constants";
import { EventBus } from "../../event-bus";
import menuConfigService from "../../services/menuConfigService";
import NotificationsCardV2 from "./notifications-card-v2";
import DocInDashboardCardV2 from "./doc-in-dashboard-card-v2";
import DocOutDashboardCardV2 from "./doc-out-dashboard-card-v2";
import UserHeader from "../../components/header/user-header";
import JobDashboardCard from "./job-dashboard-card.vue";
import utils from "../../services/utils";
import dateUtils from "../../dateUtils";
import PieChart from "../home/components/PieChart.vue";
import BarChart from "../home/components/BarChart.vue";
import draggable from "vuedraggable";
import SettingDisplay from "./components/settingDisplay.vue";

export default {
  name: "dashboard",
  components: {
    UserHeader,
    DocOutDashboardCardV2,
    DocInDashboardCardV2,
    NotificationsCardV2,
    IncomingDocsCard,
    OutgoingDocsCard,
    JobDashboardCard,
    CongViecCard,
    NotifyCard,
    ChoBanHanhCard,
    ChoTiepNhanCard,
    listTemplate: () => import("../common/list"),
    VuePerfectScrollbar,
    headerTemplate,
    PieChart,
    BarChart,
    draggable,
    SettingDisplay,
  },
  data() {
    return {
      oldConfigs: [],
      configs: [],
      DASHBBOARD_TYPE: constants.DASHBBOARD_TYPE,
      notifications: [],
      notificationsCount: null,
      notificationsUnreadCount: null,

      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      docDateRange: [null, null],

      incomingChart: null,
      outgoingChart: null,
      CVDaGiaoChart: null,
      CVDuocGiaoChart: null,

      incomingDocs: [],
      incomingDocsCount: null,
      unreadIncomingDocsCount: null,

      shareLibDocs: [],

      vanBanChoBanHanh: [],
      vanBanChoBanHanhCount: null,

      vanBanChoTiepNhan: [],
      vanBanChoTiepNhanCount: null,

      outgoingDocs: [],
      outgoingDocsCount: null,
      unreadOutgoingDocsCount: null,

      listDashBoard: [],
      dashboards: [],
      menuConfigs: [],
      checkedMenuCodes: [],
      isVisibleIncommingDoc: false,
      isVisibleOutgoingDoc: false,
      isVisibleCongViec: false,
      isVisibleChoBanHanh: false,
      isVisibleChoTiepNhan: false,
      userDeptRoleIdForIncommingDoc: null,
      userDeptRoleIdForOutgoingDoc: null,
      userDeptRoleIdForBanHanhOutgoingDoc: null,
      userDeptRoleIdForCongViec: null,
      userDeptRoleIdForHanhChinh: null,
      userDeptRoleIdForChoBanHanh: null,
      userDeptRoleIdForChoTiepNhan: null,

      // Dữ liệu công việc
      dataCVDaGiao: [],
      dataCVDuocGiao: [],

      isOpenSettingDialog: false,
      isEnableSettingDialog: false,
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    userDeptRoleView() {
      return this.$store.getters.userDeptRoleView;
    },
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
    userDeptRolesId() {
      return this.$store.getters.userDeptRoleId;
    },
    user() {
      return this.$store.getters.user;
    },
  },

  watch: {
    isOpenSettingDialog(newValue) {
      newValue && (this.isEnableSettingDialog = newValue);
    },
    userDeptRole() {
      this.configs = [];
      this.loadData();
      this.setVisible().then((res) => {
        this.getCurrentConfig().then((res) => {
          this.loadIncomingDocsDashBoard();
          this.loadIncomingChartDashBoard();
          this.loadOutgoingDocsDashBoard();
          this.loadOutgoingChartDashBoard();
          this.loadVanBanChoBanHanh();
          this.loadVanBanChoTiepNhan();
          this.loadDataCVDaGiao();
          this.loadCVDaGiaoChartDashBoard();
          this.loadCVDuocGiaoChartDashBoard();
          this.loadDataCVDuocGiao();
        });
      });
    },
  },

  created() {
    this.initDocDateRange();
    this.loadNotificationsDashBoard();
    this.loadData();
    this.setVisible().then((res) => {
      this.getCurrentConfig().then((res) => {
        this.loadIncomingDocsDashBoard();
        this.loadIncomingChartDashBoard();
        this.loadOutgoingDocsDashBoard();
        this.loadOutgoingChartDashBoard();
        this.loadVanBanChoBanHanh();
        this.loadVanBanChoTiepNhan();
        this.loadDataCVDaGiao();
        this.loadCVDaGiaoChartDashBoard();
        this.loadCVDuocGiaoChartDashBoard();
        this.loadDataCVDuocGiao();
      });
    });
  },

  methods: {
    removeItem(element) {
      let newConfig = this.oldConfigs
        .map((item) => {
          return {
            key: item.key,
            active: item.key === element ? false : item.active,
            order:
              this.configs.indexOf(item.key) !== -1
                ? this.configs.indexOf(item.key)
                : 1000,
          };
        })
        .sort((item1, item2) => {
          return utils.compareElementDashBoard(item1, item2);
        });
      dashBoardService
        .updateSettings({ data: { currentConfigs: newConfig } })
        .then((res) => {
          this.oldConfigs = newConfig;
          this.configs = newConfig
            .filter((item) => item.active)
            .map((item) => item.key);
        });
    },

    updateConfigSuccess(event) {
      let newConfigs = event.newConfigs || [];
      this.oldConfigs = newConfigs;
      this.configs = newConfigs
        .filter((item) => item.active)
        .map((item) => {
          return item.key;
        });
      this.isOpenSettingDialog = false;
    },

    getCurrentConfig() {
      return dashBoardService
        .getSettings({ userDeptRoleId: this.userDeptRolesId })
        .then((res) => {
          if (res.data && res.data.data && res.data.data.currentConfigs) {
            this.oldConfigs = res.data.data.currentConfigs;
            this.configs = this.oldConfigs
              .filter((item) => item.active)
              .map((item) => item.key);
          } else {
            this.configs = [
              "VB_DEN_LIST",
              "VB_DI_LIST",
              "VB_CHO_BAN_HANH",
              "VB_CHO_TIEP_NHAN",
              "CV_DUOC_GIAO_LIST",
              "CV_TOI_GIAO_LIST",
              "VB_DEN_CHART",
              "VB_DI_CHART",
              "CV_TOI_GIAO_CHART",
              "CV_DUOC_GIAO_CHART",
            ];
            this.oldConfigs = this.configs.map((item, index) => {
              return {
                key: item,
                order: index,
                active: true,
              };
            });
          }
        });
    },

    updateConfig(newConfig) {
      dashBoardService.updateConfig({
        userDeptRoleId: this.userDeptRolesId,
        data: newConfig,
      });
    },

    changeSort() {
      let newConfig = this.oldConfigs
        .map((item) => {
          return {
            key: item.key,
            active: item.active,
            order:
              this.configs.indexOf(item.key) !== -1
                ? this.configs.indexOf(item.key)
                : 1000,
          };
        })
        .sort((item1, item2) => {
          return utils.compareElementDashBoard(item1, item2);
        });
      dashBoardService
        .updateSettings({ data: { currentConfigs: newConfig } })
        .then((res) => {
          this.oldConfigs = newConfig;
        });
    },

    checkDisplayDashBoard(value) {
      let check = value && value.reduce((a, b) => a + b, 0);
      return check;
    },
    initDocDateRange() {
      this.docDateRange = dateUtils.getDatesByQuickFilter(
        constants.DATE_QUICK_FILTER.CODE.NAM_NAY
      );
    },
    loadData() {
      return dashBoardService
        .getData({
          fromDocDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toDocDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        })
        .then((response) => {
          this.dashboards = response.data;
          // return this.setVisible();
        });
    },

    loadDataCVDaGiao() {
      if (!this.isVisibleCongViec) {
        this.configs = this.configs.filter((x) => x !== "CV_TOI_GIAO_LIST");
      } else {
        dashBoardService
          .getDashBoardCongViecDagiao({
            page: 0,
            // size: 10,
            // sort: "docDate,desc",
            fromStartDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toStartDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((res) => {
            this.dataCVDaGiao = res.data.tasks || [];
            // if (
            //   !this.dataCVDaGiao ||
            //   !this.dataCVDaGiao.length ||
            //   this.configs.indexOf("CV_TOI_GIAO_LIST") === -1
            // ) {
            //   this.configs = this.configs.filter(
            //     (x) => x !== "CV_TOI_GIAO_LIST"
            //   );
            // }
          });
      }
    },

    loadDataCVDuocGiao() {
      if (!this.isVisibleCongViec) {
        this.configs = this.configs.filter((x) => x !== "CV_DUOC_GIAO_LIST");
      } else {
        dashBoardService
          .getDashBoardCongViecDuocGiao({
            page: 0,
            // size: 10,
            // sort: "docDate,desc",
            fromStartDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toStartDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((res) => {
            this.dataCVDuocGiao = res.data.tasks || [];
            // if (
            //   !this.dataCVDuocGiao ||
            //   !this.dataCVDuocGiao.length ||
            //   this.configs.indexOf("CV_DUOC_GIAO_LIST") === -1
            // ) {
            //   this.configs = this.configs.filter(
            //     (x) => x !== "CV_DUOC_GIAO_LIST"
            //   );
            // }
          });
      }
    },

    viewMorelOutgoingDoc() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.CHUYEN_VIEN) {
          this.userDeptRoleIdForOutgoingDoc = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForOutgoingDoc
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForOutgoingDoc,
      });
      this.$router.push({
        name: "vbDuThaoNew",
        params: { userDeptRoleId: this.userDeptRoleIdForOutgoingDoc },
      });
    },

    viewMoreIncomingDoc() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.CHUYEN_VIEN) {
          this.userDeptRoleIdForIncommingDoc = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForIncommingDoc
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForIncommingDoc,
      });
      this.$router.push({
        name: "vbDenChoXuLy",
        params: {
          userDeptRoleId: this.userDeptRoleIdForIncommingDoc,
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
      });
    },

    viewDetailIncomingDoc(event) {
      let item = event.doc;
      this.$router.push({
        name: "vbDenChoXuLyDetail",
        params: {
          id: item.id,
        },
        query: {
          fromSendTime: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toSendTime: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
          vbDocProcessId:
            item && item.vbDocUserVbDocProcessId
              ? item.vbDocUserVbDocProcessId
              : undefined,
        },
      });
    },

    viewDetailOutgoingDoc(event) {
      let item = event.doc;
      if (
        item.status == constants.OUTGOING_DOC_STATUS.TAOMOI ||
        (item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI &&
          item.creatorId == this.userId) ||
        (item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH &&
          item.creatorId == this.userId)
      ) {
        this.$router.push({
          name: "vbDuThaoNewEdit",
          params: {
            id: item.id,
            fromProcessTime: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toProcessTime: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          },
        });
      } else {
        this.$router.push({
          name: "vbDuThaoNewDetail",
          params: {
            id: item.id,
          },
          query: {
            fromProcessTime: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toProcessTime: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
            vbDocProcessId:
              item && item.vbDocUserVbDocProcessId
                ? item.vbDocUserVbDocProcessId
                : undefined,
          },
        });
      }
    },

    viewDetailChoBanHanh(event) {
      let item = event.doc;
      this.$router.replace({
        name: "vbChoBanHanhDetail",
        params: { id: item.id, userDeptRoleId: this.userDeptRolesId },
        query: this.$route.query,
      });
    },

    viewDetailChoTiepNhan(event) {
      let item = event.doc;
      this.$router.replace({
        name: "vbChoTiepNhanDetailEditable",
        params: { id: item.id },
        query: this.$route.query,
      });
    },

    viewMoreChoBanHanh() {
      this.$router.push({
        name: "vbChoBanHanh",
        params: {
          dateRange: this.docDateRange,
        },
      });
    },

    viewMoreChoTiepNhan() {
      this.$router.push({
        name: "vbChoTiepNhan",
        params: {
          dateRange: this.docDateRange,
        },
      });
    },

    loadIncomingDocsDashBoard() {
      if (!this.isVisibleIncommingDoc) {
        this.configs = this.configs.filter((x) => x !== "VB_DEN_LIST");
      } else {
        dashBoardService
          .getIncomingDocsDashBoard({
            page: 0,
            // size: 10,
            sort: "docDate,desc",
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            let incomingDocsDashBoard = response.data;
            this.incomingDocs = incomingDocsDashBoard.docs;
            this.incomingDocsCount = incomingDocsDashBoard.docsCount;
            this.unreadIncomingDocsCount =
              incomingDocsDashBoard.unreadDocsCount;
            // if (
            //   !this.incomingDocsCount ||
            //   this.configs.indexOf("VB_DEN_LIST") === -1
            // ) {
            //   this.configs = this.configs.filter((x) => x !== "VB_DEN_LIST");
            // }
          });
      }
    },

    loadIncomingChartDashBoard() {
      if (!this.isVisibleIncommingDoc) {
        this.configs = this.configs.filter((x) => x !== "VB_DEN_CHART");
      } else {
        dashBoardService
          .getIncomingChartDashBoard({
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            this.incomingChart = response.data.incomingDoc
              ? Object.values(response.data.incomingDoc)
              : null;
            // if (
            //   !this.checkDisplayDashBoard(this.incomingChart) ||
            //   this.configs.indexOf("VB_DEN_CHART") === -1
            // ) {
            //   this.configs = this.configs.filter((x) => x !== "VB_DEN_CHART");
            // }
          });
      }
    },

    loadOutgoingChartDashBoard() {
      if (!this.isVisibleOutgoingDoc) {
        this.configs = this.configs.filter((x) => x !== "VB_DI_CHART");
      } else {
        dashBoardService
          .getOutgoingChartDashBoard({
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            this.outgoingChart = response.data.outgoingDoc
              ? Object.values(response.data.outgoingDoc)
              : null;
            // if (
            //   !this.checkDisplayDashBoard(this.outgoingChart) ||
            //   this.configs.indexOf("VB_DI_CHART") === -1
            // ) {
            //   this.configs = this.configs.filter((x) => x !== "VB_DI_CHART");
            // }
          });
      }
    },

    loadCVDaGiaoChartDashBoard() {
      if (!this.isVisibleCongViec) {
        this.configs = this.configs.filter((x) => x !== "CV_TOI_GIAO_CHART");
      } else {
        dashBoardService
          .getDashBoardChartCVDagiao({
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            this.CVDaGiaoChart = response.data.taskAssigner
              ? Object.values(response.data.taskAssigner)
              : null;
            // if (
            //   !this.checkDisplayDashBoard(this.CVDaGiaoChart) ||
            //   this.configs.indexOf("CV_TOI_GIAO_CHART") === -1
            // ) {
            //   this.configs = this.configs.filter(
            //     (x) => x !== "CV_TOI_GIAO_CHART"
            //   );
            // }
          });
      }
    },

    loadCVDuocGiaoChartDashBoard() {
      if (!this.isVisibleCongViec) {
        this.configs = this.configs.filter((x) => x !== "CV_TOI_GIAO_LIST");
      } else {
        dashBoardService
          .getDashBoardChartCVDuocGiao({
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            this.CVDuocGiaoChart = response.data.taskReceive
              ? Object.values(response.data.taskReceive)
              : null;
            // if (
            //   !this.checkDisplayDashBoard(this.CVDuocGiaoChart) ||
            //   this.configs.indexOf("CV_DUOC_GIAO_CHART") === -1
            // ) {
            //   this.configs = this.configs.filter(
            //     (x) => x !== "CV_DUOC_GIAO_CHART"
            //   );
            // }
          });
      }
    },

    loadVanBanChoBanHanh() {
      if (!this.isVisibleChoBanHanh) {
        this.configs = this.configs.filter((x) => x !== "VB_CHO_BAN_HANH");
      } else {
        dashBoardService
          .getVanBanChoBanHanhDashBoard({
            page: 0,
            // size: 10,
            sort: "docDate,desc",
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            let vanBanChoBanHanhDashBoard = response.data;
            this.vanBanChoBanHanh = vanBanChoBanHanhDashBoard.docs;
            this.vanBanChoBanHanhCount = vanBanChoBanHanhDashBoard.docsCount;
            // if (
            //   !this.vanBanChoBanHanhCount ||
            //   this.configs.indexOf("VB_CHO_BAN_HANH") === -1
            // ) {
            //   this.configs = this.configs.filter(
            //     (x) => x !== "VB_CHO_BAN_HANH"
            //   );
            // }
          });
      }
    },

    loadVanBanChoTiepNhan() {
      if (!this.isVisibleChoTiepNhan) {
        this.configs = this.configs.filter((x) => x !== "VB_CHO_TIEP_NHAN");
      } else {
        dashBoardService
          .getVanBanChoTiepNhanDashBoard({
            page: 0,
            // size: 10,
            sort: "docDate,desc",
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            let vanBanChoTiepNhanDashBoard = response.data;
            this.vanBanChoTiepNhan = vanBanChoTiepNhanDashBoard.docs;
            this.vanBanChoTiepNhanCount = vanBanChoTiepNhanDashBoard.docsCount;
            // if (
            //   !this.vanBanChoTiepNhanCount ||
            //   this.configs.indexOf("VB_CHO_TIEP_NHAN") === -1
            // ) {
            //   this.configs = this.configs.filter(
            //     (x) => x !== "VB_CHO_TIEP_NHAN"
            //   );
            // }
          });
      }
    },

    loadOutgoingDocsDashBoard() {
      if (!this.isVisibleOutgoingDoc) {
        this.configs = this.configs.filter((x) => x !== "VB_DI_LIST");
      } else {
        dashBoardService
          .getOutgoingDocsDashBoard({
            page: 0,
            // size: 10,
            sort: "createTime,desc",
            fromDocDate: this.docDateRange[0]
              ? this.docDateRange[0].getTime()
              : undefined,
            toDocDate: this.docDateRange[1]
              ? this.docDateRange[1].getTime()
              : undefined,
          })
          .then((response) => {
            let outgoingDocsDashBoard = response.data;
            this.outgoingDocs = outgoingDocsDashBoard.docs;
            this.outgoingDocsCount = outgoingDocsDashBoard.docsCount;
            this.unreadOutgoingDocsCount =
              outgoingDocsDashBoard.unreadDocsCount;
            // if (
            //   !this.outgoingDocsCount ||
            //   this.configs.indexOf("VB_DI_LIST") === -1
            // ) {
            //   this.configs = this.configs.filter((x) => x !== "VB_DI_LIST");
            // }
          });
      }
    },

    loadNotificationsDashBoard() {
      dashBoardService
        .getNotificationsDashBoard({
          page: 0,
          size: 50,
          sort: "createTime,desc",
        })
        .then((response) => {
          let notificationDashBoard = response.data;
          this.notifications = notificationDashBoard.notis;
          this.notificationsCount = notificationDashBoard.countNotis;
          this.notificationsUnreadCount =
            notificationDashBoard.countNotiUnreads;
        });
    },

    loadCheckedMenu(item) {
      return menuConfigService
        .findAllByUserDeptRoleId(
          item && item.userDeptRole && item.userDeptRole.id
        )
        .then((response) => {
          this.menuConfigs = response.data;
          this.checkedMenuCodes = h.collect(
            h.findAll(
              this.menuConfigs,
              (menuConfig) =>
                menuConfig.status == constants.MENU_CONFIG.STATUS.ACTIVE
            ),
            (menuConfig) => menuConfig.menuCode
          );
          h.each(this.checkedMenuCodes, (menuCode) => {
            switch (menuCode) {
              case constants.MENU_LIST.VB_DEN_CHOXULY:
                this.userDeptRoleIdForIncommingDoc = item.userDeptRole.id;
                this.isVisibleIncommingDoc = true;
                break;
              case constants.MENU_LIST.VB_DI_DUTHAO:
                this.userDeptRoleIdForOutgoingDoc = item.userDeptRole.id;
                this.isVisibleOutgoingDoc = true;
                break;
              case constants.MENU_LIST.VB_DI_DAPHATHANH:
                this.userDeptRoleIdForBanHanhOutgoingDoc = item.userDeptRole.id;
                this.isVisibleBanHanhOutgoingDoc = true;
                break;
              case constants.MENU_LIST.CONGVIEC:
                this.userDeptRoleIdForCongViec = item.userDeptRole.id;
                this.isVisibleCongViec = true;
                break;
              case constants.MENU_LIST.VB_DEN_CHOTIEPNHAN:
                this.userDeptRoleIdForChoTiepNhan = item.userDeptRole.id;
                this.isVisibleChoTiepNhan = true;
                break;
              case constants.MENU_LIST.VB_DI_CHOBANHANH:
                this.userDeptRoleIdForChoBanHanh = item.userDeptRole.id;
                this.isVisibleChoBanHanh = true;
                break;
            }
          });
        });
    },

    setVisible() {
      return this.loadCheckedMenu({
        userDeptRole: this.$store.getters.userDeptRole,
      });
    },

    returnListJob(dataJob) {
      let jobs = [];
      if (dataJob && dataJob.length) {
        jobs = jobs.concat(
          ...dataJob.map((x) => {
            return {
              ...x,
              quote: x.taskTitle,
              userDeptRoleView: this.userDeptRoleView,
            };
          })
        );
      }
      return jobs;
    },

    viewListIncomingDocProcessing() {
      this.$router.push({
        name: "vbDenChoXuLy",
        query: {
          fromSendTime: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toSendTime: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewListOutgoingDocProcessing(item) {
      this.$router.push({
        name: "vbDuThaoNew",
        query: {
          fromProcessTime: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toProcessTime: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewListCVDaGiao(status) {
      this.$router.push({
        name: "job-index-assigned",
        query: {
          delegateFilter: "all",
          taskStatuses: this.convertTaskStatus(status),
          taskStatusFilter: this.convertStatusFilter(status),
          viewType: "assigner",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewListCVDuocGiao(status) {
      this.$router.push({
        name: "job-index",
        query: {
          taskStatuses: this.convertTaskStatus(status),
          taskStatusFilter: this.convertStatusFilter(status),
          viewType: "receiver",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
      });
    },

    viewDetailCVDuocGiao(item) {
      this.$router.push({
        name: "detail-job",
        query: {
          taskStatuses: null,
          taskStatusFilter: null,
          viewType: "receiver",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
        params: {
          id: item.id,
        },
      });
    },

    viewDetailCVDaGiao(item) {
      this.$router.push({
        name: "detail-job-assigned",
        query: {
          delegateFilter: "all",
          taskStatuses: null,
          taskStatusFilter: null,
          viewType: "assigner",
          fromStartDate: this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined,
          toStartDate: this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined,
        },
        params: {
          id: item.id,
        },
      });
    },

    convertStatusFilter(status) {
      switch (status) {
        case "CHO_PHE_DUYET_DK":
          return "choPheDuyet";
        case "DANG_THUC_HIEN":
          return "dangThucHien";
        case "HOAN_THANH":
          return "hoanThanh";
        case "KET_THUC":
          return "ketThuc";
        case "HUY":
          return "tamDung";
        default:
          return null;
      }
    },

    convertTaskStatus(status) {
      switch (status) {
        case "CHO_PHE_DUYET_DK":
          return 0;
        case "DANG_THUC_HIEN":
          return 1;
        case "HOAN_THANH":
          return 3;
        case "KET_THUC":
          return 4;
        case "HUY":
          return [2, 5, 6];
        default:
          return null;
      }
    },

    filterByDocDateRange() {
      this.getDataDashBoard();
    },

    getDataDashBoard() {
      this.loadData();
      this.loadIncomingDocsDashBoard();
      this.loadIncomingChartDashBoard();
      this.loadOutgoingDocsDashBoard();
      this.loadOutgoingChartDashBoard();
      this.loadVanBanChoBanHanh();
      this.loadVanBanChoTiepNhan();
      this.loadDataCVDaGiao();
      this.loadCVDaGiaoChartDashBoard();
      this.loadCVDuocGiaoChartDashBoard();
      this.loadDataCVDuocGiao();
    },
  },
};
</script>

<style src="./dashboard.css" lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/dashboard-index-v2-test.vue